import { render, staticRenderFns } from "./CustomProgressLabels.vue?vue&type=template&id=784aaed4"
import script from "./CustomProgressLabels.vue?vue&type=script&lang=js"
export * from "./CustomProgressLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports